import React from 'react'

import { PostOverlay } from './PostOverlay'

import { Icon } from '../Icon'

type DraftOverlayProps = {
  zIndex?: number
}

export const DraftOverlay = ({ zIndex }: DraftOverlayProps): JSX.Element => (
  <PostOverlay
    icon={<Icon name='post-pencil' size={47} color='text' padding='sm' />}
    text='DRAFT (NOT VISIBLE)'
    zIndex={zIndex ?? 0}
  />
)
